import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { IEngageCategoryPosting } from '../interfaces/engage-category-posting.interface';
import { IEngageCategoryPostingQuery } from '../interfaces/interfaces/engage-category-posting.query.interface';
import { IEngageCategoryPostingTranslationQuery } from '../interfaces/interfaces/engage-category-posting-translation.query.interface';
import { IEngageCateogoryWithPostingQuery } from '../interfaces/interfaces/engage-category-with-posting.query.interface';
import { PostingTranslation } from './posting-translation.model';

export class EngageCategoryWithPosting {
    category: {
        id: string;
        name: string;
        type: string;
        posting: IEngageCategoryPosting;
        isSelected?: boolean;
    };

    children: EngageCategoryWithPosting[];

    constructor(query: IEngageCateogoryWithPostingQuery) {
        this.category = {
            id: String(query.category.id),
            name: query.category.name,
            type: query.category.type,
            posting: EngageCategoryWithPosting._mapPosting(query.category.posting),
        };

        this.children = query.children ? query.children.map((child) => new EngageCategoryWithPosting(child)) : [];
    }

    get isExpandable(): boolean {
        return this.category.type === 'sub_categories' && this.children.length > 0;
    }

    private static _mapPosting(query: IEngageCategoryPostingQuery): IEngageCategoryPosting {
        const translationQuery = query.translation ?? query.translations?.[0] ?? null;

        return {
            id: String(query.id),
            translation: translationQuery ? EngageCategoryWithPosting._mapTranslation(translationQuery) : new PostingTranslation(),
            image: query.image ? new MaxbrainImage(query.image) : null,
            url: query.url ?? translationQuery?.url ?? null,
        };
    }

    private static _mapTranslation(translationQuery: IEngageCategoryPostingTranslationQuery): PostingTranslation {
        return new PostingTranslation({
            id: String(translationQuery.id),
            language: translationQuery.language,
            title: translationQuery.title,
            description: translationQuery.description ?? '',
        });
    }
}
